import Axios, { AxiosError } from "axios";
import { useMutation, useQueryClient } from "react-query";
import { scenarioKeys } from "src/query-keys";
import { APIError, ImportStatus, Scenario } from "src/types";

export type TrafficEmissionImportMutationData = {
  segmentFile: File;
};

export function useTrafficEmissionImportMutation(scenarioId: number | string) {
  const queryClient = useQueryClient();

  async function mutationFn(scenarioId: number | string, data: TrafficEmissionImportMutationData): Promise<void> {
    const config = {
      params: { overwrite: false },
      headers: {
        "Content-Disposition": `attachment; filename="${data.segmentFile.name}"`,
      },
    };

    return Axios.put(`/planning-api/scenarios/${scenarioId}/network/import`, data.segmentFile, config);
  }

  return useMutation<void, AxiosError<APIError[]>, TrafficEmissionImportMutationData, unknown>(
    (values: TrafficEmissionImportMutationData) => mutationFn(scenarioId, values),
    {
      onSettled: async () => {
        queryClient.setQueryData<Scenario | undefined>(scenarioKeys.detail(scenarioId), (value) => {
          if (!value) return undefined;
          return {
            ...value,
            networkImportStatus: ImportStatus.IMPORTING,
          };
        });
        await queryClient.invalidateQueries(scenarioKeys.detail(scenarioId));
      },
    }
  );
}
